export default __webpack_public_path__ + "static/media/UnionPay.71a17925.svg";